import QueryKeyFactory from "../../../api/hooks/utils/queryKeyFactory";

export const guestRequestKeys = new QueryKeyFactory('guestRequest')